import styled from 'styled-components';
import {Space} from 'antd';
import Search from '../../../Search';

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledTableFiltersSearch = styled(Search)`
  max-width: 180px;
  min-width: 150px;
  min-height: 40px;
  width: 100%;
`;

const StyledFilterElements = styled(Space)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  width: 100%;
`;

const StyledRightSideContent = styled.div`
`;

const StyledFilterElementsSpace = styled(Space)`
  & > .ant-space {
    &:last-of-type {
      margin-right: 8px;
    }
  }
  
  .ant-select.ant-select-lg {
    .ant-select-selector {
      min-width: 180px;
      min-height: 40px;
    }
  }
`;

export {
  StyledTableFiltersSearch,
  StyledTableFilters,
  StyledFilterElements,
  StyledFilterElementsSpace,
  StyledRightSideContent
};
